"use client"
import React, { useState } from "react"
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card"
import { cn } from "@/lib/utils"

interface ClickableHoverCardProps {
  trigger: React.ReactNode
  children: React.ReactNode
  className?: string
}

export default function ClickableHoverCard({
  trigger,
  children,
  className = "",
}: ClickableHoverCardProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <HoverCard
      openDelay={200}
      open={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
    >
      <HoverCardTrigger
        onClick={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        className={cn("cursor-pointer z-10", className)}
        asChild
      >
        {trigger}
      </HoverCardTrigger>
      <HoverCardContent side="top" className="pb-2">
        {children}
      </HoverCardContent>
    </HoverCard>
  )
}
